var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-stepper",
    {
      model: {
        value: _vm.statoLavorazione,
        callback: function ($$v) {
          _vm.statoLavorazione = $$v
        },
        expression: "statoLavorazione",
      },
    },
    [
      _c(
        "v-stepper-header",
        [
          _c(
            "v-stepper-step",
            { attrs: { complete: _vm.statoLavorazione > 1, step: "1" } },
            [_vm._v("Negoziazione")]
          ),
          _c("v-divider"),
          _c(
            "v-stepper-step",
            { attrs: { complete: _vm.statoLavorazione > 2, step: "2" } },
            [_vm._v("Lavorazione")]
          ),
          _c("v-divider"),
          _c(
            "v-stepper-step",
            { attrs: { complete: _vm.statoLavorazione > 3, step: "3" } },
            [_vm._v("Completamento")]
          ),
        ],
        1
      ),
      _c(
        "v-stepper-items",
        [
          _c(
            "v-stepper-content",
            { attrs: { step: "1" } },
            [
              _vm.loading
                ? _c(
                    "div",
                    {
                      staticClass: "text-xs-center",
                      staticStyle: { padding: "20px" },
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: { color: "primary", indeterminate: "" },
                      }),
                    ],
                    1
                  )
                : _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _vm._v(
                              "Data ordine: " +
                                _vm._s(_vm.ordine.innerLavorazione.data_Ordine)
                            ),
                          ]),
                          _vm.ordine.variazioneLavorazioneAttiva != null
                            ? _c("v-flex", { attrs: { xs12: "" } }, [
                                _vm._v(
                                  "Ultima data proposta: " +
                                    _vm._s(
                                      _vm.formatIsoDate(
                                        _vm.ordine.variazioneLavorazioneAttiva
                                          .variazioneDataConsegnaProposta
                                      )
                                    )
                                ),
                              ])
                            : _c("v-flex", { attrs: { xs12: "" } }, [
                                _vm._v(
                                  "Nessuna data di consegna proposta attualmente."
                                ),
                              ]),
                          _vm.azioniPossibili.includes(
                            _vm.azioni.RICHIEDI_VARIAZIONE
                          )
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      ref: "menu1",
                                      attrs: {
                                        "offset-y": "",
                                        "close-on-content-click": false,
                                        "nudge-right": 40,
                                        transition: "scale-transition",
                                        "max-width": "290px",
                                        "min-width": "290px",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-text-field",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        label:
                                                          "Nuova data proposta",
                                                        "persistent-hint": "",
                                                        "prepend-icon":
                                                          "mdi-calendar",
                                                      },
                                                      on: {
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          _vm.date =
                                                            _vm.parseDate(
                                                              _vm.dateFormatted
                                                            )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dateFormatted,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.dateFormatted =
                                                            $$v
                                                        },
                                                        expression:
                                                          "dateFormatted",
                                                      },
                                                    },
                                                    on
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1762504458
                                      ),
                                      model: {
                                        value: _vm.menu1,
                                        callback: function ($$v) {
                                          _vm.menu1 = $$v
                                        },
                                        expression: "menu1",
                                      },
                                    },
                                    [
                                      _c("v-date-picker", {
                                        attrs: { "no-title": "" },
                                        on: {
                                          input: function ($event) {
                                            _vm.menu1 = false
                                          },
                                        },
                                        model: {
                                          value: _vm.date,
                                          callback: function ($$v) {
                                            _vm.date = $$v
                                          },
                                          expression: "date",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "info", block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.invioRichiestaVariazione.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Proponi variazione")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.azioniPossibili.includes(_vm.azioni.ACCETTA)
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-divider"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "success", block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.invioAccettazione.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Accetta lavorazione")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.azioniPossibili.includes(
                            _vm.azioni.FORZA_ACCETTAZIONE_DA_PARTE_DI_BC
                          )
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-divider"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { block: "", color: "info" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.invioForzaAccettazioneParteBc.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Forza accettazione da parte di BC"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "v-stepper-content",
            { attrs: { step: "2" } },
            [
              _vm.loading
                ? _c(
                    "div",
                    {
                      staticClass: "text-xs-center",
                      staticStyle: { padding: "20px" },
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: { color: "primary", indeterminate: "" },
                      }),
                    ],
                    1
                  )
                : _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _vm.azioniPossibili.includes(
                            _vm.azioni.FORZA_CONSEGNA_A_FORNITORE_DA_PARTE_DI_BC
                          )
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { block: "", color: "info" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.invioForzaConsegnaFornitoreBc.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Forza consegna a fornitore da parte di BC"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.azioniPossibili.includes(
                            _vm.azioni.CONSEGNA_A_FORNITORE
                          )
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "info", block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.invioConsegnaAFornitore.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Consegna a fornitore")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.azioniPossibili.includes(
                            _vm.azioni.REGISTRA_CONSEGNA_A_FORNITORE
                          )
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "info", block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.invioConfermaConsegna.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Registra consegna ricevuta")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.azioniPossibili.includes(
                            _vm.azioni.INIZIA_LAVORAZIONE
                          )
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "success", block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.invioInizioLavorazione.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Inizio lavorazione")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.azioniPossibili.includes(
                            _vm.azioni.AGGIORNA_LAVORAZIONE
                          )
                            ? _c("v-flex", { attrs: { xs12: "" } }, [
                                _vm._v(
                                  "Lavorazione in corso. È possibile specificare lo stato di avanzamento delle singole attività."
                                ),
                              ])
                            : _vm._e(),
                          _vm.azioniPossibili.includes(
                            _vm.azioni.COMPLETA_LAVORAZIONE
                          )
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "success", block: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.invioCompletaLavorazione.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Completa lavorazione")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "v-stepper-content",
            { attrs: { step: "3" } },
            [
              _vm.azioniPossibili.includes(_vm.azioni.RICONSEGNA_A_BC)
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", color: "success" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.invioRiconsegnaABc.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [_vm._v("Riconsegna a BC")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.azioniPossibili.includes(_vm.azioni.REGISTRA_RIENTRO)
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", color: "success" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.invioRegistraRientro.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [_vm._v("Registra rientro")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }